import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import { meQueryOptions } from '@/lib/me';
import { pickActiveMembership } from '@/lib/membership';
import { useSession } from '@/stores/session';

/** Rental screens exist only for a rental shop (the same rule as the menu's `rentalShop`): anyone else opening the URL goes home. */
export async function requireRentalShop({
  context,
}: {
  context: { queryClient: QueryClient };
}): Promise<void> {
  const data = await context.queryClient.ensureQueryData(meQueryOptions);
  const membership = pickActiveMembership(data.memberships, useSession.getState().tenantId);
  if (!membership?.tenant.rental) throw redirect({ to: '/', replace: true });
}
